"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = void 0;
var voyageScene_create_sidecar_1 = require("@voyage/scene/voyageScene_create-sidecar");
var voyageScene_update_sidecar_1 = require("@voyage/scene/voyageScene_update-sidecar");
var create = function () {
    voyageScene_create_sidecar_1.voyageScene_create.create();
};
exports.create = create;
var update = function (time, delta) {
    voyageScene_update_sidecar_1.voyageScene_update.update(time, delta);
};
exports.update = update;
